import { Backdrop, Box, Checkbox, CircularProgress, ListItem, ListItemText, Popover } from '@mui/material';
import { listInvoiceMasterRange, listPurchaseMasterRange } from '../../../../graphql';
import { useSelector } from 'react-redux';
import { API, graphqlOperation } from 'aws-amplify';
import { useEffect, useState } from 'react';
import { useFetchGstReportPurchaseQuery, useFetchGstReportSalesQuery } from '../../../../redux/apis/GSTReport.api';
import { useThemes } from '../../../../components/Theme/theme';

const GSTDropDown = ({
  openPopover,
  anchorEl,
  handleClose,
  list,
  setGSTData,
  setBackdropOpen,
  setAnchorEl,
  selectedTab,
  selectedAccount,
  setSelectedAccount,
}) => {
  const { theme } = useThemes();
  const selectAccount = async (account) => {
    console.log(account, selectedAccount, 'llllllllllll');

    setGSTData([]);
    setAnchorEl(null);
    setBackdropOpen(true);
    if (account.accountsid == 1) {
      setSelectedAccount([{ accountsid: '001', accountname: 'GSTR 1' }]);
    } else if (account.accountsid == 2) {
      setSelectedAccount([{ accountsid: '002', accountname: 'GSTR 2' }]);
    } else if (account.accountsid == 3) {
      setSelectedAccount([{ accountsid: '003', accountname: 'GSTR 3B' }]);
    } else {
      setSelectedAccount([{ accountsid: '004', accountname: 'E way Bill List' }]);
    }
    setBackdropOpen(false);
  };

  return (
    <Popover
      id="tree-popover"
      open={openPopover}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
      sx={{
        marginTop: '10px',
        '& .MuiPaper-root': {
          maxHeight: '600px',
          overflow: 'auto',
        },
      }}
    >
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          background: '#fff',
          minWidth: '350px',
          backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? '#26282A' : '#f9f9fe',
        }}
      >
        <Box>
          {list &&
            list.length > 0 &&
            list.map((data) => {
              console.log(data, 'dddd');
              console.log(selectedAccount, 'dddd');

              return (
                <ListItem
                  key={data.accountsid}
                  sx={{
                    cursor: 'pointer',
                    '&.MuiListItem-root': {
                      paddingTop: '0px',
                      paddingBottom: '0px',
                      alignItems: 'center',
                      overflow: 'hidden',
                      '&:hover': {
                        // you can use any palette value or hard-code a color
                        backgroundColor: '#bdb7b7',
                        // bgcolor: theme => theme.palette.primary.light,
                      },
                    },
                  }}
                  onClick={() => selectAccount(data)}
                  secondaryAction={
                    <Checkbox
                      sx={{
                        marginRight: '2px',
                      }}
                      edge="end"
                      //  onChange={handleToggle(value)}
                      checked={selectedAccount?.find((acc) => acc.accountsid == data.accountsid)?.accountsid ? true : false}
                      //  inputProps={{ 'aria-labelledby': labelId }}
                    />
                  }
                >
                  <ListItemText
                    id={data.accountsid}
                    primary={`${data.accountname}`}
                    sx={{
                      // Set your desired width
                      whiteSpace: 'wrap', // Optional: Hide overflow text
                      textOverflow: 'ellipsis', // Optional: Show ellipsis for overflow text
                    }}
                  />
                </ListItem>
              );
            })}
        </Box>
      </Box>
    </Popover>
  );
};

export default GSTDropDown;
